import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { RefundCreditPaymentService } from "src/app/shared/services/refund-creditcard-payment.service";
import Swal from "sweetalert2";
import paymentOptionsConstant from "../../../../../shared/paymentOptionsConstant";
import { LanguageService } from "../../../../../shared/services/language.service";
import { Report, RowActions } from "../../../../admin/report/report";
import { SaveEventDataService } from "../../../../admin/report/services/save-event-data.service";
import { SalesReportService } from "../../services/sales-report.service";
import { SellerResendMailService } from "src/app/dashboard/admin/report/services/seller-resend-mail.service";
import { SaveCalendarDataService } from "../../services/save-calendar-data.service";
import { AmanRefundInquiryService } from "src/app/shared/services/aman-refund-inquiry.service";
import { ContactSendOTPService } from "src/app/public-website/buyer/services/contact-send-otp.service";

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.scss']
})
export class SalesComponent implements OnInit {
  tableColumns: string[] = [
    "productName",
    "paymentMethod",
    "status",
    "Quantity",
    "amount",
    "merchantRefNumber",
    "promocodeTitle",
    "refNumber",
    "buyerName",
    "buyerEmail",
    "buyerMobile",
    "dateStr",
    "reason",
    "createdBy"
  ];

  displayTableColumns = {};
  oldTickets: object = {};
  curuntTicket = [];
  totalNumberOfRecords = 0;
  salesReportData: any[] = [];
  constructor(
    protected salesReportService: SalesReportService,
    protected SaveEventData: SaveEventDataService,
    protected sellerResendMailService: SellerResendMailService,
    protected translate: TranslateService,
    protected languageService: LanguageService,
    protected refundService: RefundCreditPaymentService,
    protected saveCalendarData: SaveCalendarDataService,
    protected amanRefundInquiryService: AmanRefundInquiryService,
    protected sendOTPService: ContactSendOTPService,
  ) { }

  filterField: any[] = [];

  rowActions: RowActions[] = [
    {
      actionName: "Resend-email",
      actionType: "icon",
      iconClass: "fa-envelope",
      actionDisableEnableField: 'status',
      actionEnableValues: ['PAID']
    },
    {
      actionName: 'Refund',
      actionType: 'icon',
      iconClass: 'fa-money-bill-transfer',
      actions: [
        {
          field: 'status',
          enabled: true,
          values: ['PAID'],
        },
        {
          field: 'paymentMethod',
          enabled: true,
          values: [
            paymentOptionsConstant.constantPaymentOptions.value.CREDIT_CARD,
            paymentOptionsConstant.constantPaymentOptions.value.Mogo,
            paymentOptionsConstant.constantPaymentOptions.value.TRU,
            paymentOptionsConstant.constantPaymentOptions.value.Contact,
            paymentOptionsConstant.constantPaymentOptions.value.VALU,
            paymentOptionsConstant.constantPaymentOptions.value.SOUHOOLA,
            paymentOptionsConstant.constantPaymentOptions.value.Aman_Installments,
          ],
        },
      ],
    },
  ];

  requestBody: Report = {};
  loading = false;
  reportName: string = '';

  async ngOnInit() {
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        this.loadArContent();
      } else if (localStorage.getItem("language") === "en") {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === "ar") {
        this.loadArContent();
      } else if (lang === "en") {
        this.loadEnContent();
      }
    });
    this.salesReportService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  loadArContent() {
    this.reportName = 'تقرير المبيعات';
    this.translate.use('ar');

    this.displayTableColumns = {
      productName: "المنتج",
      paymentMethod: "طرق الدفع",
      status: "الحالة",
      Quantity: "العدد",
      amount: "المبلغ",
      merchantRefNumber: "الرقم المرجعي للتاجر",
      promocodeTitle: "عنوان البروموكود",
      refNumber: "الرقم المرجعي",
      buyerName: "إسم المشترٍ",
      buyerEmail: "بريد الإليكترونى المشترٍ",
      buyerMobile: "هاتف المشترٍ",
      dateStr: "التاريخ",
      reason: "سبب الرفض  ",
      createdBy: " تم بواسطة "
    };

    this.filterField = [
      {
        filterFieldName: "status",
        filterDisplayName: "الحالة",
        defaultValue: "",
        filterOptions: [
          { key: "إظهار الكل", value: null },
          { key: "جديد", value: "NEW" },
          { key: "مدفوع", value: "PAID" },
          { key: "منتهى الصلاحية", value: "EXPIRED" },
          { key: "باءت بالفشل", value: "FAILED" },
          { key: "استرداد", value: "REFUNDED" },
        ]
      },
      {
        filterFieldName: "paymentMethod",
        filterDisplayName: "طريقة الدفع",
        defaultValue: "",
        filterOptions: [
          { key: "إظهار الكل", value: null },
          { key: 'النقد عن طريق فوري', value: paymentOptionsConstant.constantPaymentOptions.value.Fawry },
          { key: 'بطاقة الائتمان والخصم', value: paymentOptionsConstant.constantPaymentOptions.value.CREDIT_CARD },
          { key: 'النقد عن طريق أمان', value: paymentOptionsConstant.constantPaymentOptions.value.CASH },
          { key: 'محفظة الهاتف المحمول', value: paymentOptionsConstant.constantPaymentOptions.value.Mobile_Wallet },
          { key: 'ميزة', value: paymentOptionsConstant.constantPaymentOptions.value.MEEZA },
          { key: 'حر', value: paymentOptionsConstant.constantPaymentOptions.value.Free },
          { key: 'موجو', value: paymentOptionsConstant.constantPaymentOptions.value.Mogo },
          { key: 'ترو', value: paymentOptionsConstant.constantPaymentOptions.value.TRU },
          { key: 'بطاقة الائتمان والخصم (باي سكاي)', value: paymentOptionsConstant.constantPaymentOptions.value.PaySky },
          { key: 'التقسيط عن طريق فاليو', value: paymentOptionsConstant.constantPaymentOptions.value.PaySky }
        ]
      }
    ];
  }

  loadEnContent() {
    this.reportName = 'Sales Report';
    this.translate.use('en');

    this.displayTableColumns = {
      productName: "Product",
      paymentMethod: "Payment Methode",
      status: "Status",
      Quantity: "Quantity",
      amount: "Amount",
      merchantRefNumber: "Merchant Ref Number",
      promocodeTitle: "Promocode Title",
      refNumber: "Reference Number",
      buyerName: "Buyer Name",
      buyerEmail: "Buyer Email",
      buyerMobile: "Buyer Mobile",
      dateStr: "Date",
      reason: "Reason",
      createdBy: "Created By"
    };

    this.filterField = [
      {
        filterFieldName: "status",
        filterDisplayName: "Status",
        defaultValue: "",
        filterOptions: [
          { key: "Show All", value: null },
          { key: "New", value: "NEW" },
          { key: "Paid", value: "PAID" },
          { key: "Expired", value: "EXPIRED" },
          { key: "Failed", value: "FAILED" },
          { key: "Refund", value: "REFUNDED" },
        ]
      },
      {
        filterFieldName: "paymentMethod",
        filterDisplayName: "Payment Method",
        defaultValue: "",
        filterOptions: [
          { key: "Show All", value: null },
          { key: paymentOptionsConstant.constantPaymentOptions.name.Fawry, value: paymentOptionsConstant.constantPaymentOptions.value.Fawry },
          { key: paymentOptionsConstant.constantPaymentOptions.name.CREDIT_CARD, value: paymentOptionsConstant.constantPaymentOptions.value.CREDIT_CARD },
          { key: paymentOptionsConstant.constantPaymentOptions.name.CASH, value: paymentOptionsConstant.constantPaymentOptions.value.CASH },
          { key: paymentOptionsConstant.constantPaymentOptions.name.Mobile_Wallet, value: paymentOptionsConstant.constantPaymentOptions.value.Mobile_Wallet },
          { key: paymentOptionsConstant.constantPaymentOptions.name.MEEZA, value: paymentOptionsConstant.constantPaymentOptions.value.MEEZA },
          { key: paymentOptionsConstant.constantPaymentOptions.name.Free, value: paymentOptionsConstant.constantPaymentOptions.value.Free },
          { key: paymentOptionsConstant.constantPaymentOptions.name.PaySky, value: paymentOptionsConstant.constantPaymentOptions.value.PaySky },
          { key: paymentOptionsConstant.constantPaymentOptions.name.VALU, value: paymentOptionsConstant.constantPaymentOptions.value.VALU },
          { key: paymentOptionsConstant.constantPaymentOptions.name.SOUHOOLA, value: paymentOptionsConstant.constantPaymentOptions.value.SOUHOOLA },
          { key: paymentOptionsConstant.constantPaymentOptions.name.Mogo, value: paymentOptionsConstant.constantPaymentOptions.value.Mogo },
          { key: paymentOptionsConstant.constantPaymentOptions.name.TRU, value: paymentOptionsConstant.constantPaymentOptions.value.TRU },
          { key: paymentOptionsConstant.constantPaymentOptions.name.APPLE_PAY, value: paymentOptionsConstant.constantPaymentOptions.value.APPLE_PAY },
        ]
      }
    ];
  }

  actionsCB(object: any) {
    console.log("hey from the resport", object);
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.salesReportService.loader().subscribe((val: any) => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.salesReportService.loader().subscribe((val: any) => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.salesReportService.loader().subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.salesReportService.loader().subscribe((val: any) => (this.loading = val));
  }


  private formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const m = date.getMonth() + 1;     // months are 0 indexed

    const month = ("0" + m).slice(-2); // add a 0 padding
    const year = date.getFullYear();
    const day = ("0" + date.getDate()).slice(-2); // add a 0 padding
    return `${year}-${month}-${day}`;
  }

  async updateTable() {
    if (this.SaveEventData.date && this.SaveEventData.refnum) {
      this.requestBody['filterOptions'] = { createdAt: this.SaveEventData.date };
      this.requestBody.searchOptions = { searchKey: this.SaveEventData.refnum };
      this.SaveEventData.date = null;
      this.SaveEventData.refnum = null;
    } else if (this.saveCalendarData.date && this.saveCalendarData.refnum) {
      this.requestBody['filterOptions'] = { createdAt: this.saveCalendarData.date };
      this.requestBody.searchOptions = { searchKey: this.saveCalendarData.refnum };
      this.saveCalendarData.date = null;
      this.saveCalendarData.refnum = null;
    } else if (this.requestBody['filterOptions'] && this.requestBody['filterOptions']['createdAt']) {
      const { startDate, endDate } = this.requestBody['filterOptions']['createdAt'] as any;
      this.requestBody.filterOptions.createdAt.from = this.formatDate(startDate) + " 00:00:00";
      this.requestBody.filterOptions.createdAt.to = this.formatDate(endDate) + " 23:59:59";
    }
    this.salesReportService.activateLoader();
    this.salesReportService.setParams(this.requestBody);
    const report = await this.salesReportService.make();
    this.salesReportData = report.result.map((p: any) => {
      if ((!p.productName || p.productName == "") && p.paymentMethod != "Cash Api") {
        if (p.paymentMethod == "Qassatly") {
          p.productName = `Quick Qassatly ${p.amount}`
        } else {
          p.productName = `Quick Payment ${p.amount}`;
        }
      }
      if (p.paymentMethod == "Cash Api" && (!p.productName || p.productName == "")) {
        p.productName = `Cash Api ${p.amount}`;
      }
      p.dateStr = moment(p.dateStr).add(2,'hours').format('MMMM D YYYY, hh:mm A')
      return p;
    });
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  closePopup() {
    this.curuntTicket = [];
  }

  async rowActionClicked(event: Event) {
    switch (event.action) {
      case 'Resend-email':
        await this.resendEmail(event);
        break;
      case 'Refund':
        await this.refund(event);
        break;
    }
  }

 private async resendEmail(event: Event) {
    const productName = { value: event.key.productName }
    const buyerContactInfo = {
      buyer_email: event.key.buyerEmail,
      buyer_phone: event.key.buyerMobile,
      buyer_name: event.key.buyerName
    }



    this.sellerResendMailService.setParams({
      refNum: event.key.merchantRefNumber,
      productName,
      buyerContactInfo
    })
    await this.sellerResendMailService.make()
  }

  private async refund(event: Event) {
    try {
      const data = event.key;
      if (
        !paymentOptionsConstant.refundPaymentOtions.includes(
          data.paymentMethod,
        )
      ) {
        await Swal.fire({
          icon: 'error',
          title: this.translate.instant('FORM_TEMPLATE.ERROR_TITLE'),
          text: this.translate.instant('FORMS.VALIDATION.IVALID', {
            field: this.translate.instant('Sellers.Products.PaymentMethod'),
          }),
        });
        return;
      }

      const isOTP = await this.refundOTP(data.paymentMethod, data.merchantRefNumber);

      await Swal.fire({
        title: this.translate.instant('PROVIDER.CREDIT.REFUNDWARNING'),
        text: isOTP ? "Buyer OTP!" : "",
        input: isOTP ? "text" : undefined,
        showCancelButton: true,
        confirmButtonText: this.translate.instant('Sellers.Products.Change'),
        showLoaderOnConfirm: true,
        preConfirm: async (otp: string) => {
          await this.callRefundService(data.merchantRefNumber, otp);
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    } catch (error) {
      console.log({ error });
    }
  }

  private async callRefundService(refNum: string, otp?: string) {
    try {
      this.refundService.setParams({ refNum, otp });
      await this.refundService.make();
      await Swal.fire({
        icon: 'success',
        title: this.translate.instant('FORM_TEMPLATE.SUCCESS_TITLE'),
        text: this.translate.instant('Sellers.Products.Done'),

      });
    } catch (err) {
      const massage = err.faultyRequest.error?.message;
      await Swal.fire({
        icon: 'error',
        title: this.translate.instant('FORM_TEMPLATE.ERROR_TITLE'),
        text: massage ?? err.faultyRequest.error.error,
      });
    }
  }

  private async refundOTP(paymentMethod: string, merchantRefNumber: string) {
    try {
      switch (paymentMethod) {
        case paymentOptionsConstant.constantPaymentOptions.name
          .Aman_Installments:
          this.amanRefundInquiryService.setParams({
            trxRef: merchantRefNumber,
          });
          await this.amanRefundInquiryService.make();
          return true;
        case paymentOptionsConstant.constantPaymentOptions.name.Contact:
          this.sendOTPService.setParams({
            justSendOTP: true,
            refNum: merchantRefNumber,
          });
          await this.sendOTPService.make();
          return true;
      }

      return false;
    } catch (err) {
      const massage = err.faultyRequest.error?.message;
      await Swal.fire({
        icon: 'error',
        title: this.translate.instant('FORM_TEMPLATE.ERROR_TITLE'),
        text: massage ?? err.faultyRequest.error.error,
      });
      return false;
    }
  }
}
type Event = {
  action: "Refund" | "Resend-email" | string;
  key: SalesRow;
};

type SalesRow = {
  BusinessId: number;
  CardStatus: number;
  Quantity: number;
  amount: string;
  buyerEmail: string;
  buyerMobile: string;
  buyerName: string;
  createdBy: string;
  date: string;
  dateStr: string;
  discountValue: string;
  merchantRefNumber: string;
  paId: number;
  paymentMethod: string;
  prId: number;
  productName: string;
  productType: string;
  promocodeTitle: string;
  reason: string;
  refNumber: string;
  reservationType: string;
  status: string;
  ticketType: string;
};

